webpackJsonp([26],{

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var lightBig = this.el.querySelector("#illuminati-light-big");
      var lightSmall = this.el.querySelector("#illuminati-light-small");

      TweenMax.set([lightBig, lightSmall], { transformOrigin: "center" });

      this.animation = new TimelineMax({ repeat: -1, yoyo: true }).fromTo(lightBig, 1.5, { scale: 0.6 }, { scale: 1.1, ease: Expo.easeOut }, 0).fromTo(lightSmall, 1.5, { scale: 0.5 }, { scale: 1.2, ease: Bounce.easeOut }, 0.2);

      this.animation.paused(!this.props.isActive);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.animation.paused(!nextProps.isActive);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        { ref: function ref(el) {
            return _this2.el = el;
          }, viewBox: "0 0 600 600" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M600 300c0 165.69-134.31 300-300 300S0 465.69 0 300 134.31 0 300 0s300 134.31 300 300",
          fill: "#558B2F"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          id: "illuminati-light-big",
          fill: "#FFF",
          d: "M300 248.76L326.78 45.2l-16.13 204.68 68.52-193.54-58.33 196.85L428.1 78.13l-97.98 180.42 141.31-148.94-133.35 156.1 169.19-116.3-162.9 124.97 189.68-78.59-185.32 88.38 201.87-37.44-199.64 47.91L556.2 300l-205.24 5.36 199.64 47.91-201.87-37.44 185.32 88.38-189.68-78.59 162.9 124.97-169.19-116.3 133.35 156.1-141.31-148.94 97.98 180.42-107.26-175.06 58.33 196.85-68.52-193.54 16.13 204.68L300 351.24 273.22 554.8l16.13-204.68-68.52 193.54 58.33-196.85L171.9 521.87l97.98-180.42-141.31 148.94 133.35-156.1-169.19 116.3 162.9-124.97-189.68 78.59 185.32-88.38L49.4 353.27l199.64-47.91L43.8 300l205.24-5.36L49.4 246.73l201.87 37.44-185.32-88.38 189.68 78.59-162.9-124.97 169.19 116.3-133.35-156.1 141.31 148.94L171.9 78.13l107.26 175.06-58.33-196.85 68.52 193.54L273.22 45.2z"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          id: "illuminati-light-small",
          fill: "#444",
          d: "M296.24 257.38l7.34-171.27 1.6 171.42 42.79-166-34.07 168.01 76.36-153.48-68.25 157.25 106.6-134.25-99.45 139.63 132.18-109.15-126.31 115.89 151.99-79.28-147.65 87.1 165.15-45.94-162.53 54.5 171.1-10.61-170.31 19.52 169.56 25.19-170.65-16.32 160.62 59.91-163.52-51.45 144.65 91.99-149.25-84.32 122.37 120.06-128.47-113.51 94.74 142.87L320.77 337.4l62.96 159.45-71.19-155.95 28.43 169.06-37.21-167.34-7.34 171.27-1.6-171.42-42.79 166 34.07-168.01-76.36 153.48 68.25-157.25-106.6 134.25 99.45-139.63-132.18 109.15 126.31-115.89-151.99 79.28 147.65-87.1-165.15 45.94 162.53-54.5-171.1 10.61 170.31-19.52-169.56-25.19 170.65 16.32L97.69 230.5l163.52 51.45-144.65-91.99 149.25 84.32-122.37-120.06 128.47 113.51-94.74-142.87L279.23 262.6l-62.96-159.45 71.19 155.95-28.43-169.06z"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          fill: "#33691E",
          stroke: "#FFF",
          strokeWidth: "27",
          strokeMiterlimit: "10",
          d: "M121.32 431.46L300 113.6l178.68 317.86z"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M216.34 327.48l46.5-31.13c23.63-11.26 51.12-11.09 74.61.46l46.72 22.97-52.15 26.94c-20.02 10.34-43.72 10.72-64.06 1.04l-51.62-20.28z",
          fill: "#FFF"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "298.55", cy: "319.79", r: "38.42", fill: "#212121" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "298.55", cy: "321.4", r: "29.88", fill: "#282828" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M335.51 289.28c-21.59-10.49-46.78-10.56-68.42-.18 0 0-49.69 30.82-53.15 36.51-1.36 2.24-.4 5.16 2.03 6.13l45.7 18.31c24.33 11.34 52.54 10.71 76.35-1.69l36.2-18.87c4.94-2.58 9.21-6.27 12.47-10.79l-51.18-29.42zm2.3 51.27c-23.92 10.76-54.71 11.04-81.87-.6l-23.49-10.06c-2.31-.99-2.87-4.02-1.07-5.77 11.08-10.75 25.06-18.04 40.23-20.91.14-.03.27-.05.41-.08.75-.14 1.5-.27 2.25-.4 16.87-2.8 34.1-2.63 50.92.5.09.02.18.03.27.05 10.63 2 13.05 4.27 19.5 8.79 4.17 2.92 8.04 6.25 11.57 9.93 3.31 3.44 2.21 9.13-2.15 11.09l-16.57 7.46z",
          fill: "#212121"
        })
      );
    }
  }]);

  return _class;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (_class);

/***/ })

});


// WEBPACK FOOTER //
// 26.9d2c02ca4551d54d3025.js